import { LevelData } from '../level-data';

export const level12: LevelData = {
    name: 'Speed Demon',
    timeLimit: 90,
    track: [
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '--   --',
        '-------',
        '-------',
        '---B---',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '--   --',
        '-------',
        '-------',
        '---B---',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '--   --',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
